import { call, debounce, put, takeLatest } from 'redux-saga/effects'
import { navigate } from '@reach/router'

// redux
import * as aceModule from '../modules/ace'
import * as aceApi from '../apiModules/ace'

function* fetchTrainingTemplates({ payload }) {
  try {
    const response = yield call(aceApi.fetchTrainingTemplates, payload)
    yield put(aceModule.fetchTrainingTemplatesSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchTrainingTemplatesFailure(err))
  }
}

function* fetchTrainingTemplate({ payload }) {
  try {
    const response = yield call(aceApi.fetchTrainingTemplate, payload)
    yield put(aceModule.fetchTrainingTemplateSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchTrainingTemplateFailure(err))
  }
}

function* updateTrainingTemplate({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const updatedTemplate = yield call(aceApi.updateTrainingTemplate, formDataVals)
    yield put(aceModule.updateTrainingTemplateSuccess(updatedTemplate))

    navigate(`/dashboard/training-records/templates`)
  } catch (err) {
    yield put(aceModule.updateTrainingTemplateFailure())
  }
}

function* deleteTrainingTemplate({ payload }) {
  try {
    const { trainingTemplateId } = payload
    yield call(aceApi.deleteTrainingTemplate, { trainingTemplateId })
    yield put(aceModule.deleteTrainingTemplateSuccess(payload))

    navigate(`/dashboard/training-records/templates`)
  } catch (err) {
    yield put(aceModule.deleteTrainingTemplateFailure())
  }
}

function* bulkAssignTrainingTemplate({ payload }) {
  try {
    yield call(aceApi.bulkAssignTrainingTemplate, payload)
    yield put(aceModule.bulkAssignTrainingTemplateSuccess())

    navigate(`/dashboard/training-records`)
  } catch (err) {
    yield put(aceModule.bulkAssignTrainingTemplateFailure(err.response.data))
  }
}

function* createSideHustle({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    yield call(aceApi.createSideHustle, formDataVals)
    yield put(aceModule.createSideHustleSuccess())

    navigate(`/dashboard/side-hustles`)
  } catch (err) {
    yield put(aceModule.createSideHustleFailure(err.response.data))
  }
}

function* createTrainingRecord({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    yield call(aceApi.createTrainingRecord, formDataVals)
    yield put(aceModule.createTrainingRecordSuccess())

    navigate(`/dashboard/training-records`)
  } catch (err) {
    yield put(aceModule.createTrainingRecordFailure(err.response.data))
  }
}

function* createTrainingTemplate({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    yield call(aceApi.createTrainingTemplate, formDataVals)
    yield put(aceModule.createTrainingTemplateSuccess())

    navigate(`/dashboard/training-records`)
  } catch (err) {
    yield put(aceModule.createTrainingTemplateFailure(err.response.data))
  }
}

function* createWorkRecord({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    yield call(aceApi.createWorkRecord, formDataVals)
    yield put(aceModule.createWorkRecordSuccess())

    navigate(`/dashboard/work-records`)
  } catch (err) {
    yield put(aceModule.createWorkRecordFailure(err.response.data))
  }
}

function* deleteSideHustle({ payload }) {
  try {
    const { sideHustleId } = payload
    yield call(aceApi.deleteSideHustle, { sideHustleId })
    yield put(aceModule.deleteSideHustleSuccess(payload))

    navigate(`/dashboard/side-hustles`)
  } catch (err) {
    yield put(aceModule.deleteSideHustleFailure())
  }
}

function* deleteTrainingRecord({ payload }) {
  try {
    const { recordId } = payload
    yield call(aceApi.deleteTrainingRecord, { recordId })
    yield put(aceModule.deleteTrainingRecordSuccess(payload))

    navigate(`/dashboard/training-records`)
  } catch (err) {
    yield put(aceModule.deleteTrainingRecordFailure())
  }
}

function* deleteWorkRecord({ payload }) {
  try {
    const { recordId } = payload
    yield call(aceApi.deleteWorkRecord, { recordId })
    yield put(aceModule.deleteWorkRecordSuccess(payload))

    navigate(`/dashboard/work-records`)
  } catch (err) {
    yield put(aceModule.deleteWorkRecordFailure())
  }
}

function* fetchSideHustle({ payload }) {
  try {
    const response = yield call(aceApi.fetchSideHustle, payload)
    yield put(aceModule.fetchSideHustleSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchSideHustleFailure(err))
  }
}

function* fetchSideHustles({ payload }) {
  try {
    const response = yield call(aceApi.fetchSideHustles, payload)
    yield put(aceModule.fetchSideHustlesSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchSideHustlesFailure(err))
  }
}

function* fetchTrainingRecord({ payload }) {
  try {
    const response = yield call(aceApi.fetchTrainingRecord, payload)
    yield put(aceModule.fetchTrainingRecordSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchTrainingRecordFailure(err))
  }
}

function* fetchTrainingRecords({ payload }) {
  try {
    const response = yield call(aceApi.fetchTrainingRecords, payload)
    yield put(aceModule.fetchTrainingRecordsSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchTrainingRecordsFailure(err))
  }
}

function* fetchWorkRecord({ payload }) {
  try {
    const response = yield call(aceApi.fetchWorkRecord, payload)
    yield put(aceModule.fetchWorkRecordSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchWorkRecordFailure(err))
  }
}

function* fetchWorkRecords({ payload }) {
  try {
    const response = yield call(aceApi.fetchWorkRecords, payload)
    yield put(aceModule.fetchWorkRecordsSuccess(response))
  } catch (err) {
    yield put(aceModule.fetchWorkRecordsFailure(err))
  }
}

function* updateSideHustle({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const updatedRecord = yield call(aceApi.updateSideHustle, formDataVals)
    yield put(aceModule.updateSideHustleSuccess(updatedRecord))

    navigate(`/dashboard/side-hustles`)
  } catch (err) {
    yield put(aceModule.updateSideHustleFailure())
  }
}

function* updateTrainingRecord({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (value === 'multi_documents') return

      if (value === 'new_multi_documents') {
        const files = payload[value] || []
        files.forEach(file => {
          formDataVals.append('new_multi_documents', file)
        })
        return
      }

      if (value === 'removed_multi_document_ids') {
        if ((payload[value] || []).length) {
          formDataVals.append('removed_multi_document_ids', JSON.stringify(payload[value]))
        }
        return
      }

      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const updatedRecord = yield call(aceApi.updateTrainingRecord, formDataVals)
    yield put(aceModule.updateTrainingRecordSuccess(updatedRecord))

    navigate(`/dashboard/training-records`)
  } catch (err) {
    yield put(aceModule.updateTrainingRecordFailure())
  }
}

function* updateWorkRecord({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const updatedRecord = yield call(aceApi.updateWorkRecord, formDataVals)
    yield put(aceModule.updateWorkRecordSuccess(updatedRecord))

    navigate(`/dashboard/work-records`)
  } catch (err) {
    yield put(aceModule.updateWorkRecordFailure())
  }
}

function* searchAceSkills({ payload }) {
  try {
    const response = yield call(aceApi.searchAceSkills, payload)
    yield put(aceModule.searchAceSkillsSuccess(response))
  } catch (err) {
    yield put(aceModule.searchAceSkillsFailure(err))
  }
}

export const aceSagas = [
  takeLatest(aceModule.BULK_ASSIGN_TRAINING_TEMPLATE, bulkAssignTrainingTemplate),
  takeLatest(aceModule.FETCH_TRAINING_TEMPLATE, fetchTrainingTemplate),
  takeLatest(aceModule.FETCH_TRAINING_TEMPLATES, fetchTrainingTemplates),
  takeLatest(aceModule.UPDATE_TRAINING_TEMPLATE, updateTrainingTemplate),
  takeLatest(aceModule.DELETE_TRAINING_TEMPLATE, deleteTrainingTemplate),
  takeLatest(aceModule.CREATE_SIDE_HUSTLE, createSideHustle),
  takeLatest(aceModule.CREATE_TRAINING_RECORD, createTrainingRecord),
  takeLatest(aceModule.CREATE_TRAINING_TEMPLATE, createTrainingTemplate),
  takeLatest(aceModule.CREATE_WORK_RECORD, createWorkRecord),
  takeLatest(aceModule.DELETE_SIDE_HUSTLE, deleteSideHustle),
  takeLatest(aceModule.DELETE_TRAINING_RECORD, deleteTrainingRecord),
  takeLatest(aceModule.DELETE_WORK_RECORD, deleteWorkRecord),
  takeLatest(aceModule.FETCH_SIDE_HUSTLE, fetchSideHustle),
  takeLatest(aceModule.FETCH_SIDE_HUSTLES, fetchSideHustles),
  takeLatest(aceModule.FETCH_TRAINING_RECORD, fetchTrainingRecord),
  takeLatest(aceModule.FETCH_TRAINING_RECORDS, fetchTrainingRecords),
  takeLatest(aceModule.FETCH_WORK_RECORD, fetchWorkRecord),
  takeLatest(aceModule.FETCH_WORK_RECORDS, fetchWorkRecords),
  takeLatest(aceModule.UPDATE_SIDE_HUSTLE, updateSideHustle),
  takeLatest(aceModule.UPDATE_TRAINING_RECORD, updateTrainingRecord),
  takeLatest(aceModule.UPDATE_WORK_RECORD, updateWorkRecord),
  debounce(400, aceModule.SEARCH_ACE_SKILLS, searchAceSkills)
]
